import { RecommenderProviderTypeEnum } from '@/constant';
import { NOOP } from '@/utils';

import { ColumnTypes } from '../common/table/type';

export const TriggerSelectRecommenderClick = {
	show: NOOP,
};

export const initialValues = {
	searchType: RecommenderProviderTypeEnum.RECOMMEND_NAME,
	searchValue: '',
};

export enum PageTypeEnumSelectRecommender {
	FRANCHISE = 'FRANCHISE',
	APPLICANT = 'APPLICANT',
}

export const PAGE_TYPE_ENUM_SELECT_RECOMMENDER_MAP = {
	[PageTypeEnumSelectRecommender.FRANCHISE]: '고용주',
	[PageTypeEnumSelectRecommender.APPLICANT]: '근로자',
};

export type TValues = typeof initialValues;

export const getColumns = (): ColumnTypes => [
	{
		title: `ID`,
		dataIndex: 'id',
		key: 'id',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '구분',
		dataIndex: 'typeName',
		key: 'typeName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '추천자',
		dataIndex: 'name',
		key: 'name',
		align: 'center',
		fixed: 'left',
	},

	{
		title: '추천자 전화번호',
		dataIndex: 'phone',
		key: 'phone',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '배우자',
		dataIndex: 'spouseName',
		key: 'spouseName',
		align: 'center',
		fixed: 'left',
	},
	{
		title: '등록일',
		dataIndex: 'registDt',
		key: 'registDt',
		align: 'center',
		fixed: 'left',
	},
];
